import { Component, ViewChild } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { SelectComponent } from 'ng2-select';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { EditableComponent } from '../../../../shared/components/interfaces/editable.component';
import { ListeableComponent } from '../../../../shared/components/interfaces/listeable.component';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { DataTableUtils } from '../../../../shared/utils/data-table.utils';
import { MiscellaneousUtils } from '../../../../shared/utils/miscellaneous.utils';
import { AuthService } from '../../../security/service/auth.service';
import { MakeUIMessages } from '../../model/make-ui.messages';
import { MakeModel } from '../../model/make.model';
import { MakeService } from '../../service/make.service';
import { MakeAddDialogComponent } from '../make-add-dialog/make-add-dialog.component';

@Component({
  selector: 'make-list',
  templateUrl:
    'console/app-js/modules/make/components/list/make-list.component.html'
})
export class MakeListComponent extends APIOperableComponent
  implements ListeableComponent, EditableComponent {
  @ViewChild('auditFilterSelect', { static: true })
  protected auditFilterSelect: SelectComponent;
  protected data: Array<MakeModel> = [];
  private originalData: Array<MakeModel> = [];
  protected filters: any = [
    {
      property: 'name',
      type: 'string',
      value: ''
    },
    {
      property: 'isActive',
      type: 'boolean',
      options: ['Active', 'Inactive'],
      value: null
    },
    {
      property: 'requiresAudit',
      type: 'boolean',
      options: ['Yes', 'No'],
      value: null
    }
  ];
  protected showInactive = false;

  constructor(
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    protected dialogService: UIDialogService,
    private makeService: MakeService
  ) {
    super(progressService, toastr, authService);

    this.onSearch();
  }

  /**
   * Initialize data.
   */
  init(): void {
    this.originalData = [];
    this.data = [];
  }

  onAddItem(): void {
    this.dialogService
      .open(MakeAddDialogComponent, [{ provide: 'makeModel', useValue: null }])
      .then(result => {
        if (result) {
          this.onSearch();
        }
      })
      .catch(result => {
        // Silence is golden.
      });
  }

  onEditItem(make: MakeModel): void {
    this.dialogService
      .open(MakeAddDialogComponent, [
        { provide: 'makeModel', useValue: make },
        {
          provide: 'currentMakeNames',
          useValue: this.originalData.map(item => item.name)
        }
      ])
      .then(result => {
        if (result) {
          this.onSearch();
        }
      })
      .catch(result => {
        // Silence is golden.
      });
  }

  onSearch(): void {
    this.startProgress();
    this.makeService.getMakes(this.showInactive).subscribe(
      result => {
        this.data = result;
        this.originalData = MiscellaneousUtils.cloneArray(this.data);
        this.onFilterData();
        this.finishProgress();
      },
      err => this.onAPIError(MakeUIMessages.LOAD_MAKES_LIST_ERROR)
    );
  }

  onSave(): void {
    this.progressRef.start();
    this.onAPISuccess(MakeUIMessages.EDIT_MAKES_SUCCESS);
    this.onReset();
    this.init();
    this.onSearch();
  }

  onCancel(param: any): void {
    // Silence is golden.
  }

  isDirty(): boolean {
    return JSON.stringify(this.originalData) !== JSON.stringify(this.data);
  }

  onReset(): void {
    this.filters[0].value = '';
    this.filters[1].value = null;
    this.auditFilterSelect.active = [];
    this.filters[2].value = null;
    this.data = DataTableUtils.filterDataByProperties(
      this.data,
      this.originalData,
      this.filters
    );
  }

  /**
   * On Include Inactive Records checkbox change.
   * @param $event
   */
  protected onShowInactiveChange($event: any): void {
    this.onSearch();
  }

  /**
   * On Filter input text data.
   */
  protected onFilterData(): void {
    this.data = DataTableUtils.filterDataByProperties(
      this.data,
      this.originalData,
      this.filters
    );
  }

  /**
   * On Audit dropdown select event.
   * @param $event
   */
  protected onSelectAuditOption($event: any): void {
    this.filters[2].value =
      $event.id === this.filters[2].options[0] ? true : false;
    this.data = DataTableUtils.filterDataByProperties(
      this.data,
      this.originalData,
      this.filters
    );
  }

  /**
   * On Audit dropdown clear event.
   */
  protected clearAuditFilter(): void {
    this.filters[2].value = null;
    this.data = DataTableUtils.filterDataByProperties(
      this.data,
      this.originalData,
      this.filters
    );
  }

  onFullscreenMode(): void {
    // not yet implemented
  }

  onDeleteItems(): void {
    // not yet implemented
  }
}
